<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>

    <!--     <ion-title>
      Select a Product
    </ion-title> -->
<ion-label>

  <smr-stylist-picker
  *ngIf="stylist"
  [stylistID]="stylist.getID()"
  [readOnly]="readOnlyStylistPicker"
  (onInit)="onStylistPickerInit($event)"
  (stylistSelect)="onStylistSelect($event)"
  cssClass="smr-stylist-picker-for-productspicker"
  ></smr-stylist-picker>
</ion-label>

    <ion-buttons slot="end">
      <ion-button
        
        [disabled]="isLoading || errorOccurredWhileLoadingProducts || errorOccurredWhileLoadingStylistPicker"
        (click)="createProduct()"
      >
        <ion-icon name="add"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-searchbar
          placeholder="Search products"
          [(ngModel)]="searchVal"
          (ionChange)="onSearch()"
        >
        </ion-searchbar>
      </ion-col>
      <!-- <ion-col col-auto *ngIf="platform.is('cordova')">
        <button 
          ion-button
          icon-only
          clear
          (tap)="onBarcodeScan()"
          >
          <ion-icon name="barcode"></ion-icon>
        </button>
      </ion-col> -->
    </ion-row>
    <!--ion-title>sale-product-picker</!--ion-title-->
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container
    *ngIf="!(isLoading || errorOccurredWhileLoadingProducts || errorOccurredWhileLoadingStylistPicker)"
  >
    <smr-product-list [products]="rows" (productSelect)="productSelect($event)">
    </smr-product-list>
  </ng-container>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingProducts || errorOccurredWhileLoadingStylistPicker"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>
</ion-content>
